<template>

  <div class="pageTableDiagram">
    <div class="row justify-content-center ">
      <div class="col-12">
        <div class="card-diagram-info d-flex justify-content-between">
          <h2>dd.mm.rrrr – dd.mm.rrrr</h2>
          <div class="wrapper-btn ">
            <b-button variant="secondary"
                      class="custom">
              <span class="icon icon-print pr-2"></span>

              Drukuj
            </b-button>


            <b-button variant="primary"
                      class="custom ">
              <span class="icon icon-save pr-2"></span>

              Zapisz
            </b-button>


          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped custom table-status">
          <thead>
          <tr>
            <th scope="col">Dni / Godziny</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>
            <th scope="col">gg:mm</th>

          </tr>
          </thead>
          <tbody>
          <tr>
            <th scope="row">dd.mm.rrrr</th>
            <td  colspan="12" class="text-center">
              <span class="liner-status-table"></span>
            </td>
          </tr>
          <tr>
            <th scope="row">dd.mm.rrrr</th>
            <td  colspan="12" >
              <span class="liner-status-table two"></span>
            </td>
          </tr>
          <tr>
            <th scope="row">dd.mm.rrrr</th>
            <td  colspan="12" class="text-right" >
              <span class="liner-status-table three"></span>
            </td>
          </tr>
          <tr>
            <th scope="row">dd.mm.rrrr</th>
            <td  colspan="12" class="text-center"></td>
          </tr>
          <tr>
            <th scope="row">dd.mm.rrrr</th>
            <td  colspan="12" class="text-center"></td>
          </tr>


          </tbody>
        </table>
      </div>
    </div>
    <b-row>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        class=" custom"
      ></b-pagination>

    </b-row>
  </div>

</template>

<script>
  export default {
    name: 'TableDiagram'
  }
</script>

<style scoped>

</style>
